// TODO: Improve this function

class ScxGalleryThumbs extends HTMLElement {
  constructor() {
    super();
    this.gallerySwiper = null;
    this.thumbSwiper = null;
  }

  connectedCallback() {
    if (document.readyState === "complete") {
        // If already loaded, initialize immediately
        this.initializeSwipers();
      } else {
        // Otherwise, wait for the load event
        window.addEventListener("load", () => {
          this.initializeSwipers();
        });
      }
  }

  initializeSwipers() { 

    // Select within this component and outside for thumbs
    const galleryEl = this;
    const thumbsEl = document.querySelector('.thumbs-swiper');
    
    const nextEl = this.querySelector('._swiper-button-next');
    const prevEl = this.querySelector('._swiper-button-prev');

    if (!galleryEl || !thumbsEl) {
      console.warn("Missing gallery or thumbs swiper elements");
      return;
    }

    // Initialize thumb swiper (outside this component)
    this.thumbSwiper = new Swiper(thumbsEl, {
      spaceBetween: 10,
      slidesPerView: 8,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        1024: {
          slidesPerView: 10,
        },
      },
    });

    // Initialize gallery swiper (inside this component)
    this.gallerySwiper = new Swiper(galleryEl, {
      spaceBetween: 12,
      slidesPerView: this.getAttribute("data-mobile-slides-per-view") ?? 1,
      breakpoints: {
        750: {
          slidesPerView: this.getAttribute("data-tablet-slides-per-view") ?? 1,
        },
        990: {
          slidesPerView: this.getAttribute("data-desktop-slides-per-view") ?? 1,
        },
      },
      navigation: {
        nextEl,
        prevEl,
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
      ...this.getPaginationOptions(),
    });

  }

  getPaginationOptions = () => {
    const mwElem = this.getAttribute("data-pagination-elem");
    if (mwElem) {
      return {
        pagination: {
          el: mwElem,
          dynamicBullets:
            this.getAttribute("data-dynamic-bullets") == "true" ? true : false,
        },
      };
    }

    return {};
  };
}

customElements.define("scx-gallery-thumbs", ScxGalleryThumbs);
